var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ia-cliente-carteira",
      class: { "ia-cliente-carteira--sem-carteira": _vm.semCarteira }
    },
    [
      _vm.carregando
        ? [
            _c(
              "span",
              { staticClass: "ia-cliente-carteira__rotulo ia-texto-selo" },
              [_vm._v(_vm._s(_vm.rotulo))]
            ),
            _c(
              "BaseLoadingSkeleton",
              _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_VALOR, false)
            ),
            _c("span", { staticClass: "ia-cliente-carteira__barra-pendente" }),
            _c(
              "BaseLoadingSkeleton",
              _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_CLASSE, false)
            )
          ]
        : _c("IaInsightCard", {
            attrs: {
              variante: "hero",
              navegavel: _vm.navegavel,
              rotulo: _vm.rotulo,
              valor: _vm.valor,
              destaque: _vm.destaque,
              "tom-destaque": _vm.tomDaVariacao,
              legenda: _vm.legenda
            },
            on: {
              abrir: function($event) {
                return _vm.$emit("abrir")
              }
            }
          }),
      _vm.temAlocacao
        ? _c("IaClienteAlocacao", { attrs: { fatias: _vm.fatiasDoGrafico } })
        : _vm._e(),
      _vm.temCurva
        ? _c("IaSparkline", {
            staticClass: "ia-cliente-carteira__curva",
            attrs: { serie: _vm.serie, fantasma: _vm.carregando }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }